module.exports = __webpack_public_path__ + "static/media/DocumentationCenterIcon.31cd5d5e.svg";